<div class="progress-hill-container p-1">
  <div class="progress-hill-header m-3">
    <div class="progress-hill-header-title">
      Task progress
      <div class="progress-hill-header-title-sub">
        Project: {{projectName}},
        Task: {{strippedWorkpackageName}}
      </div>
    </div>
    <div class="btn-group" role="group" >
      <button type="button" class="btn my-btn noborder" (click)="saveTime()" data-bs-toggle="tooltip" data-bs-placement="top" title="Save progress" data-bs-delay="{show: 1000}">
        <i class="bi bi-save"></i>
      </button>
      <button class="btn my-btn noborder" (click)="close()" data-bs-toggle="tooltip" data-bs-placement="top" title="Close window without saving" data-bs-delay="{show: 1000}">
        <span class="mdi--close"></span>
      </button>
    </div>
  </div>

    <div class="mt-3">
      @if (progressPoints.length > 0 && showProgressHill == true) {
        <app-progresshill [progressPoints]="progressPoints" (progressHillUpdated)="onProgressHillUpdated($event)"></app-progresshill>
      }
    </div>
  
    <div class="progress-hill-header m-3">
      <div class="progress-hill-header-title">
        Report your work in this task
        <div class="progress-hill-header-title-sub">
          Total reported hours for this task: {{totalReportedHours}}
        </div>
      </div>
    </div>
    <div class="m-3">
        <div class="d-flex">
          <div class="m-3">
            <label for="datepicker" class="form-label">Start date</label>
            <input type="date" class="form-control" id="datepicker" [(ngModel)]="startDate" (ngModelChange)="onStartDateChange($event)">
          </div>
          <div class="m-3">
            <label for="datepicker" class="form-label">End date</label>
            <input type="date" class="form-control" id="datepicker" [(ngModel)]="endDate" (ngModelChange)="onEndDateChange($event)">
          </div>
        </div>
        <div class="d-flex">
          <div class="m-3">
            <label for="datepicker" class="form-label">Date</label>
            <input type="date" class="form-control" id="datepicker" [(ngModel)]="pickedDate">
          </div>
          <div class="m-3">
            <label for="exampleFormControlInput1" class="form-label">Hours</label>
            <input type="number" class="form-control" id="exampleFormControlInput1"  min="0"  [(ngModel)]="reportedHours" placeholder="type working hours">
          </div>
        </div>
      <div class="mb-3">
        <label for="exampleFormControlTextarea1" class="form-label">Notes (optional)</label>
        <textarea class="form-control" id="exampleFormControlTextarea1" rows="3" [(ngModel)]="taskNotes"></textarea>
      </div>
    </div>

      <div class="m-3" >
        <button type="button" class="btn my-btn" (click)="saveTime()">
          <i class="bi bi-save me-1"></i>Save
        </button>
      </div>

</div>